var _style, _g, _path, _path2, _path3, _path4, _g2, _path5, _g3, _g4, _path6, _g5, _g6, _g7, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 250",
    style: {
      enableBackground: "new 0 0 350 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.87;}\r\n\t.st1{fill:#4D87B9;enable-background:new    ;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#070707;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#E3E3E3;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#F0F9FF;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#D3D3D3;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#CCE9FF;}\r\n\t.st8{opacity:0.6;}\r\n\t.st9{fill:#0D538E;}\r\n\t.st10{fill:#4D87B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.4,119.4c4.6,12.6,17.1,42-2.3,70.8c-18.6,27.8-56.2,37.9-87.6,44.8c-23.5,4.6-146.4,31.3-195.5-40.4 c-4.1-5.6-30.5-47.7-14.5-80.9c11-22.6,35.4-24.3,88.2-61c8.8-6,11.6-8.3,11.6-8.3c0.6-0.5,2.3-2.1,4.8-3.8c0,0,2.2-1.5,4.6-2.8 c32.7-17.1,63.5-13.3,86.7-7.2c23.1,6.4,38.7,15.2,38.7,15.3C312.8,73,328.5,111.4,331.4,119.4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.9,108.9L173,71.4c-5.3-3-11.3-3-16.6,0l-91.3,52.7c-2,1.1-3.1,3.1-3.1,5.4c0,2.3,1.1,4.2,3.1,5.4 l63.8,36.9L237.9,108.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174,63.3c-5.2-3-11.1-3-16.2,0l-89.3,51.6c-1.9,1.1-3.1,3-3.1,5.3v7.5c0,2.2,1.1,4.2,3.1,5.3l64,36.9 L239,108.3v-7.5L174,63.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.9,100.8l-65-37.5c-5.2-3-11.1-3-16.2,0l-89.3,51.6c-1.9,1.1-3.1,3-3.1,5.3s1.1,4.2,3.1,5.3l64,36.9 L238.9,100.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.8,172.2l67.9,39.2c5.3,3.1,11.3,3.1,16.6,0l91.3-52.7c2-1.1,3.1-3.1,3.1-5.4c0-2.3-1.1-4.2-3.1-5.4 l-66.8-38.6L129.8,172.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st6",
    d: "M239.8,105.9l-106.6,61.6v2.9l65,37.5c5.2,3,11.1,3,16.2,0l89.3-51.6c1.9-1.1,3-3,3-5.3v-2.9 c0-2.2-1.1-4.2-3-5.3L239.8,105.9z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.2,167.4l65,37.5c5.2,3,11.1,3,16.2,0l89.3-51.6c1.9-1.1,3-3,3-5.3s-1.1-4.2-3-5.3l-64-36.9L133.2,167.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "237.1,110.3 240,112 242.9,110.3 240,108.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "230.9,113.9 233.8,115.5 236.7,113.9 233.8,112.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "224.8,117.4 227.6,119.1 230.5,117.4 227.6,115.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "218.6,121 221.5,122.7 224.4,121 221.5,119.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "212.4,124.6 215.3,126.2 218.2,124.6 215.3,122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "206.3,128.1 209.1,129.8 212,128.1 209.1,126.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "200.1,131.7 203,133.4 205.9,131.7 203,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "193.9,135.2 196.8,136.9 199.7,135.2 196.8,133.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "187.8,138.8 190.6,140.5 193.5,138.8 190.6,137.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "181.6,142.4 184.5,144 187.4,142.4 184.5,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "175.4,145.9 178.3,147.6 181.2,145.9 178.3,144.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "169.3,149.5 172.1,151.1 175,149.5 172.1,147.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "163.1,153.1 166,154.7 168.9,153.1 166,151.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "156.9,156.6 159.8,158.3 162.7,156.6 159.8,154.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "150.8,160.2 153.6,161.8 156.5,160.2 153.6,158.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "144.6,163.7 147.5,165.4 150.4,163.7 147.5,162.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "138.4,167.3 141.3,168.9 144.2,167.3 141.3,165.6  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "228,100.7 230.9,102.4 233.8,100.7 230.9,99.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "221.8,104.3 224.7,105.9 227.6,104.3 224.7,102.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "215.7,107.8 218.6,109.5 221.4,107.8 218.6,106.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "209.5,111.4 212.4,113.1 215.3,111.4 212.4,109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "203.3,114.9 206.2,116.6 209.1,114.9 206.2,113.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "197.2,118.5 200.1,120.2 202.9,118.5 200.1,116.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "191,122.1 193.9,123.7 196.8,122.1 193.9,120.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "184.8,125.6 187.7,127.3 190.6,125.6 187.7,124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "178.7,129.2 181.6,130.9 184.4,129.2 181.6,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "172.5,132.8 175.4,134.4 178.3,132.8 175.4,131.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "166.3,136.3 169.2,138 172.1,136.3 169.2,134.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "160.2,139.9 163.1,141.5 165.9,139.9 163.1,138.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "154,143.4 156.9,145.1 159.8,143.4 156.9,141.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "147.8,147 150.7,148.7 153.6,147 150.7,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "141.7,150.6 144.6,152.2 147.4,150.6 144.6,148.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "135.5,154.1 138.4,155.8 141.3,154.1 138.4,152.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "129.3,157.7 132.2,159.3 135.1,157.7 132.2,156  "
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90.8,138.4l41.5,24v4.6v2.9l-48-27.7l-15.9-9.2c-1.9-1.1-3.1-3-3.1-5.3V124v-3.8c0,1.2,0.3,2.3,1,3.3 c0.5,0.8,1.2,1.5,2.1,2L90.8,138.4z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.7,150.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C288.6,150.1,288.6,150.1,288.7,150.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,154.5c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C280.9,154.5,281,154.5,281,154.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.4,158.9c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C273.3,158.9,273.3,158.9,273.4,158.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.7,163.3c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C265.6,163.3,265.7,163.3,265.7,163.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.1,167.7c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C258,167.7,258,167.7,258.1,167.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.4,172.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C250.4,172.1,250.4,172.1,250.4,172.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.8,176.5c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C242.7,176.5,242.8,176.5,242.8,176.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.2,181c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C235.1,180.9,235.1,181,235.2,181z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.5,185.4c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C227.4,185.4,227.5,185.4,227.5,185.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.9,189.8c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C219.8,189.8,219.8,189.8,219.9,189.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.2,194.2c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3L153.9,160c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C212.1,194.2,212.2,194.2,212.2,194.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.6,198.6c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C204.5,198.6,204.6,198.6,204.6,198.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.9,203c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C196.9,203,196.9,203,196.9,203z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.1,100.7c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C221,100.7,221.1,100.7,221.1,100.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.5,105.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C213.4,105.1,213.4,105.1,213.5,105.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.8,109.5c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.5-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C205.8,109.5,205.8,109.5,205.8,109.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.2,113.9c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C198.1,113.9,198.1,113.9,198.2,113.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.6,118.3c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C190.5,118.3,190.5,118.3,190.6,118.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.9,122.8c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C182.8,122.7,182.9,122.8,182.9,122.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.3,127.2c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3L116.9,93c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C175.2,127.2,175.2,127.2,175.3,127.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.6,131.6c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.7C167.5,131.6,167.6,131.6,167.6,131.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,136c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.5-33.7c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3l58.5,33.8 C159.9,136,159.9,136,160,136z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.3,140.4c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3L94,106.2c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.5,33.8C152.2,140.4,152.3,140.4,152.3,140.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.7,144.8c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C144.6,144.8,144.6,144.8,144.7,144.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.1,149.2c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3L78.7,115c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C137,149.2,137,149.2,137.1,149.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4,153.6c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0-0.3-0.1-0.3l-58.4-33.8c-0.1-0.1-0.3,0-0.3,0.1c-0.1,0.1,0,0.3,0.1,0.3 l58.4,33.8C129.3,153.6,129.4,153.6,129.4,153.6z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240,110.9c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C239.8,110.9,239.9,110.9,240,110.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M233.8,114.5c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C233.7,114.4,233.8,114.5,233.8,114.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.7,118c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5c0.9,1.5,1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C227.5,118,227.6,118,227.7,118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.5,121.6c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C221.3,121.6,221.4,121.6,221.5,121.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.3,125.1c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C215.2,125.1,215.2,125.1,215.3,125.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.2,128.7c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.3-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C209,128.7,209.1,128.7,209.2,128.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M203,132.3c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C202.8,132.2,202.9,132.3,203,132.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196.9,135.8c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C196.7,135.8,196.8,135.8,196.9,135.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.7,139.4c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.3-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.2,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C190.5,139.4,190.6,139.4,190.7,139.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M184.5,142.9c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,1-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C184.3,142.9,184.4,142.9,184.5,142.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.4,146.5c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,1-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5c0.9,1.5,1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C178.2,146.5,178.3,146.5,178.4,146.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.2,150.1c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C172,150,172.1,150.1,172.2,150.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M166,153.6c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.3-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C165.8,153.6,165.9,153.6,166,153.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.9,157.2c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.3-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C159.7,157.2,159.8,157.2,159.9,157.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.7,160.7c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C153.5,160.7,153.6,160.7,153.7,160.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M147.5,164.3c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7c0.3,0.1,0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C147.3,164.3,147.4,164.3,147.5,164.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M141.4,167.9c0.2,0,0.4-0.1,0.5-0.3c0.4-0.7,0.5-1.5,0.5-2.4c0-1.6-0.5-3.4-1.5-5.1c-1-1.7-2.3-3.1-3.7-3.9 c-1.1-0.7-2.2-0.9-3.2-0.7c-1,0.2-1.8,0.9-2.2,2c-0.1,0.3,0,0.6,0.3,0.7s0.6,0,0.7-0.3c0.3-0.7,0.8-1.2,1.4-1.3 c0.7-0.2,1.5,0,2.4,0.5c1.2,0.7,2.4,1.9,3.3,3.5s1.4,3.1,1.4,4.6c0,0.7-0.1,1.4-0.4,1.9c-0.1,0.3,0,0.6,0.2,0.8 C141.2,167.8,141.3,167.9,141.4,167.9z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M245.7,68.6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.abab0e298f7f43add41fa309f85fba62.svg";
export { ForwardRef as ReactComponent };